import PropTypes from "prop-types"
import UnifiedSearch from "modules/unified-search"
import EmptySearch from "components/compare-search/empty"
import { RECENT_INSTRUMENT_SEARCH_TYPES } from "resources/instruments"
import "./style.scss"

function CompareSearch({ account, modelId, itemsActions, close, disableSearchResult, researchTopicId }) {
  return (
    <div className="research-topic-settings-search">
      <UnifiedSearch
        disablePortal
        autoFocus
        account={account}
        modelId={modelId}
        searchType={RECENT_INSTRUMENT_SEARCH_TYPES.EXPERIMENT}
        compositeAssetType="RESEARCH_TOPIC"
        compositeAssetId={researchTopicId}
        itemsActions={itemsActions}
        onSelect={close}
        emptyContent={<EmptySearch />}
        disableResult={disableSearchResult}
        hiddenTypes={["researchTopics", "currencies"]}
      />
    </div>
  )
}

CompareSearch.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  researchTopicId: PropTypes.string.isRequired,
  itemsActions: PropTypes.object.isRequired,
  close: PropTypes.func,
  disableSearchResult: PropTypes.func.isRequired,
}

export default CompareSearch
